import { combineReducers } from 'redux'
import {
  closeToastNotification,
  showToastNotification,
} from 'shared/store/actions/toastNotification'

import { createReducer } from 'typesafe-actions'

const toast = createReducer<{ body: React.ReactNode; open: boolean } | null>(null)
  .handleAction(showToastNotification, (_, action) => {
    return {
      body: action.payload.body,
      open: true,
    }
  })
  .handleAction(closeToastNotification, (state) => {
    return {
      body: state?.body ?? '',
      open: false,
    }
  })

export default combineReducers({
  toast,
})
